import '@/plugins/vue-composition-api'
import '@/styles/fonts.scss'
import '@/styles/styles.scss'
import Vue from 'vue'
import routes from "@/router/routes"

import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import api from './api'

import TokenMixin from '@/mixins/TokenMixin'
import UtilsMixin from '@/mixins/UtilsMixin.vue'

import Fetcher from '@/prototype/Fetcher'
import Formatter from '@/prototype/Formatter'
import Validator from '@/prototype/Validator'
import CommonFn from '@/prototype/CommonFn'

import PageHeaderSlot from './components/PageHeaderSlot.vue'
import FormButton from './components/layout/FormButton.vue'

import i18n from "@/i18n"; // 引入 I18n 套件
import HighchartsVue from 'highcharts-vue';

Vue.config.productionTip = false

Vue.use(api)
Vue.use(CommonFn)
Vue.use(Validator)
Vue.use(Formatter)
Vue.use(Fetcher)
Vue.mixin(TokenMixin)
Vue.mixin(UtilsMixin)
Vue.use(HighchartsVue)

Vue.component('PageHeaderSlot', PageHeaderSlot)
Vue.component('FormButton', FormButton)
Vue.prototype.$appMode = process.env.VUE_APP_RUN_MODE;
Vue.prototype.$mediaPath = `${process.env.VUE_APP_MEDIA_DOMAIN}/media/`;
Vue.prototype.$reportPath = `${process.env.VUE_APP_MEDIA_DOMAIN}/media/`;

Vue.prototype.$settings = {
  startTime: process.env.VUE_APP_START_TIME,
  endTime: process.env.VUE_APP_END_TIME,
  interval: process.env.VUE_APP_INTERVAL,
}

Vue.prototype.$encryptKey = '-----BEGIN PUBLIC KEY-----\nMIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA9eqyLtAuY3LkXj5+Zk63\nUv3Z3k8hpW194O/acuctjceiYZ0ollyXCCjBwEdoIrDc8hFbVZmQd8otTAyOFxQS\nPDVrmKDX8CMdo/JqXVN6zf1Waxvg068ULnG2VwG97wOm9bb5zLKMBSvrLgEAYfZU\nnWcSppzvobPL8XP2Du/1lqFN+jbyEit17KmQi4KF+OWB+qlTnn2zCMBdieEFp411\nNUkUn3M0pfb4G4/oeS7cYGqnSwNL58mHRdPYeT4oT38QPM/Uw7SdW810AMV9Zgnc\nk23ecXMiygcaOF2d72R09o6SE3aVzdEZhdqUsc4omNTDb7x3C99dKyKBLzvKDb+V\nhT3OhA8D82t3NyVF0TEAYE3fmA1LkKcfPYg3XixSArMOnTNZUIaudXdJDHSzDneR\nvPu02ufnY/ANoPK5HHXuoim+VKRZ/QZ7/MlrCGiiNXhamrgsa0/wRdZPiSRj8r2X\ns9zauvqeQgaJzR/60f0K8hUFD85mbKxTDJtS0Lu42JPrfAGXnT4MVo6w67zX/u1T\nH93NgCxOyKH18FztnRIjmRTYPnsiuYUfTU8eLXEINrsWkn4MzlOTCN8av0P7Ovy3\nGLGX5F9Ow83bHxYnLH+qkOV2ufkXSYVmAYCeUHPnJITGIKMpYbRvhMoV0UI4eS66\nhBXtZcH66SeHg0rFB56yXnsCAwEAAQ==\n-----END PUBLIC KEY-----';

i18n.init().then(async (oI18n) => {
  // **************** 會員等級
  const memberOptions = [
    { value: 'normal', text: oI18n.t('memberLevelOption.normal') },
    { value: 'B', text: oI18n.t('memberLevelOption.B') },
    { value: 'C', text: oI18n.t('memberLevelOption.C') },
    { value: 'D', text: oI18n.t('memberLevelOption.D') },
    { value: 'K', text: oI18n.t('memberLevelOption.K') },
    /* { value: 'vip', text: oI18n.t('memberLevelOption.vip') }, */
  ];
  Vue.prototype.$memberOptions = memberOptions;
  Vue.filter('formatMemberLevel', function (value) {
    if (!value) return '';
    const target = memberOptions.find(el => el.value === value);
    return target ? target.text : value;
  })

  // **************** 性別
  const genderOptions = [
    { value: 'M', text: oI18n.t('genderOption.M') },
    { value: 'F', text: oI18n.t('genderOption.F') },
  ];
  Vue.prototype.$genderOptions = genderOptions;
  Vue.filter('formatGender', function (value) {
    if (!value) return '';

    const target = genderOptions.find(el => el.value === value);
    return target ? target.text : value;
  })

  // **************** 訂單類別
  Vue.filter('formatOrderType', function (value) {
    if (!value) return '';

    const status = {
      'product': oI18n.t('orderTypeOption.product'),
      'package': oI18n.t('orderTypeOption.package'),
    };
    const statusText = status[value];
    return statusText !== undefined && statusText !== null ? statusText : value;
  })

  // **************** 訂單狀態
  Vue.filter('formatOrderStatus', function (value) {
    if (!value) return '';

    const status = {
      'pending': oI18n.t('orderStatusOption.pending'),
      'paid': oI18n.t('orderStatusOption.paid'),
      'expired': oI18n.t('orderStatusOption.expired'),
      'null': oI18n.t('orderStatusOption.null'),
      'processing': oI18n.t('orderStatusOption.processing'),
      'debit': oI18n.t('orderStatusOption.debit'),
      'void': oI18n.t('orderStatusOption.void'),
      'partially_paid': oI18n.t('orderStatusOption.partially_paid'),
    }

    const statusText = status[value];

    return statusText !== undefined && statusText !== null ? statusText : value;
  })

  // **************** 出席狀態
  Vue.filter('formatAttendanceStatus', function (value) {
    if (!value) return '';

    const status = {
      'pending': oI18n.t('attendanceStatus.pending'),
      'attend': oI18n.t('attendanceStatus.attend'),
      'absent': oI18n.t('attendanceStatus.absent'),
      'skip': oI18n.t('attendanceStatus.skip'),
      'reschedule': oI18n.t('attendanceStatus.reschedule'),
      'drop': oI18n.t('attendanceStatus.drop'),
      'swap': oI18n.t('attendanceStatus.swap'),
    }

    const statusText = status[value];

    return statusText !== undefined && statusText !== null ? statusText : value;
  })

  // **************** 套票類型
  const packageTypeOptions = [
    { value: 'month', text: oI18n.t('packageTypes.month') },
    { value: 'credit', text: oI18n.t('packageTypes.credit') },
    { value: 'dollar', text: oI18n.t('packageTypes.dollar') },
  ];
  Vue.prototype.$packageTypeOptions = packageTypeOptions;

  // **************** 付款方式
  Vue.prototype.$paymentMethodOptions = [
    { value: 'cash', text: oI18n.t('paymentMethod.cash') },
    { value: 'fps', text: oI18n.t('paymentMethod.fps') },
    { value: 'bank_transfer', text: oI18n.t('paymentMethod.bank_transfer') },
    { value: 'payme', text: oI18n.t('paymentMethod.payme') },
    { value: 'visa', text: oI18n.t('paymentMethod.visa') },
    { value: 'master', text: oI18n.t('paymentMethod.master') },
    { value: 'wechat_pay', text: oI18n.t('paymentMethod.wechat_pay') },
    { value: 'alipay', text: oI18n.t('paymentMethod.alipay') },
    { value: 'unionpay', text: oI18n.t('paymentMethod.unionpay') },
  ];


  routes.forEach(el => {
    if (el.meta?.title) {
      el.meta.title = oI18n.t(el.meta.title);
    }
    router.addRoute(el);
  })

  try {
    const ImportStatic = await import(`@/static/${process.env.VUE_APP_RUN_MODE}`);
    Vue.use(ImportStatic.default);
  } catch (err) {
    console.error(err);
  }
  let calendarTimes = [];
  try {
    let start_hour = parseInt(setting.startTime.split(':')[0]);
    let start_minute = parseInt(setting.startTime.split(':')[1]);
    const end_hour = parseInt(setting.endTime.split(':')[0]);
    const end_minute = parseInt(setting.endTime.split(':')[1]);
    let generate_hour = start_hour;
    for (let hour = generate_hour; hour < end_hour; hour++) {
      calendarTimes.push({"start_time": `${hour.toString().padStart(2, '0')}:${start_minute.toString().padStart(2, '0')}`, 'end_time': `${(hour+1).toString().padStart(2, '0')}:${end_minute.toString().padStart(2, '0')}`});
    }

  } catch (err) {
  } finally {
  }
    Vue.prototype.$calendarTimes = calendarTimes;

  new Vue({
    router,
    store,
    vuetify,
    i18n: oI18n,
    render: h => h(App),
  }).$mount('#app')
})

